<template>
  <v-card-title class="px-0 py-0 d-flex align-center justify-between">
    <v-col cols="2" style="text-align: start;">
      <span class="text-h5 heading">{{title}}</span>
    </v-col>
    <v-col cols="10" class="d-flex align-center justify-end py-0 px-0" v-if="showSpecialFilter">
      <v-col cols="2" style="text-align: start;">
        <v-label>Work Space</v-label>
        <AutoComplete :items="workSpaceData" multiple="true" item-value="name" item-title="name"
          density="compact" placeholder="WorkSpace" :model-value="formData.workSpace"
          @update:modelValue="$emit('update:formData', { ...formData, workSpace: $event })"
          :disabled="showReadOnly" />
      </v-col>
      <v-col cols="2" style="text-align: start;">
        <v-label>Account</v-label>
        <AutoComplete :items="accountData" multiple="true" item-value="name" item-title="name"
          density="compact" placeholder="Account" :model-value="formData.account"
          @update:modelValue="$emit('update:formData', { ...formData, account: $event })"
          :disabled="showReadOnly" />
      </v-col>
      <v-col cols="2" style="text-align: start;">
        <v-label>Project</v-label>
        <AutoComplete :items="projectData" multiple="true" item-value="name" item-title="name"
          density="compact" placeholder="Project" :model-value="formData.project"
          @update:modelValue="$emit('update:formData', { ...formData, project: $event })"
          :disabled="showReadOnly" />
      </v-col>
      <v-col cols="2" style="text-align: start;">
        <v-label>Next Action</v-label>
        <AutoComplete :items="nextActionData" multiple="true" item-value="name" item-title="name"
          density="compact" placeholder="Next Action" :model-value="formData.nextAction"
          @update:modelValue="$emit('update:formData', { ...formData, nextAction: $event })"
          :disabled="showReadOnly" />
      </v-col>
      <v-col cols="1">
        <v-btn color="#2563eb" @click="$emit('apply')">Apply</v-btn>
      </v-col>
    </v-col>
  </v-card-title>
</template>

<script>
import AutoComplete from '@/components/ui/AutoComplete.vue';

export default {
  name: 'QcExceptionHeader',

  components: { AutoComplete },

  props: {
    workSpaceData: { type: Array, default: () => [] },
    accountData:   { type: Array, default: () => [] },
    projectData:   { type: Array, default: () => [] },
    nextActionData:{ type: Array, default: () => [] },
    formData:      { type: Object, required: true },
    showReadOnly:  { type: Boolean, default: false },
    title : { type: String, default: 'QC Errors' },
    showSpecialFilter: {type: Boolean,default: false}
  },

  emits: ['update:formData', 'apply'],
};
</script>

<style scoped>
.heading { font-weight: 700; }
</style>
